import { Layout } from 'components/layout';
import styles from './styles.module.css';

import { CheckRtpBlock } from '../check-rtp-block';
import { Slot } from './slot';

import { Description } from 'components/description';

import { CardsMedium } from 'components/slider/cards/medium';

import { CustomMetadata } from 'components/metadata';
import { Anchor } from 'constants/anchors';
import { Reviews } from './table-reviews';

import { allMetadata } from 'constants/metadata';
import { Routes } from 'constants/routes';
import { getItemIdentifier } from 'utils/slug';

import { ICasino, INavItem, IProvider, ISlot } from 'constants/types';

import { Icon } from 'common/icon';
import { Breadcrumbs } from 'components/bredcrambs';
import { FAQComponent } from 'components/casino-faq';
import { slotPage as slotPageBreadCrumbs } from 'constants/routes-breadcrumbs';
import { useSlotReviewsBySlotQuery } from 'hooks/api/slot_reviews';
import { NavigationBar } from '../casino/casino-navigations';
import { PlayBlock } from './play';
import VideoSlider from './video-slider';

export interface Props {
  slot: ISlot;
  slotProvider: IProvider | null;
  forRealMoneyCasinos: ICasino[];
}

export const SlotPage = ({
  slot,
  slotProvider,
  forRealMoneyCasinos,
}: Props) => {
  const { data: { results: reviews = [], count: countReviews = 0 } = {} } =
    useSlotReviewsBySlotQuery({ slot_id: slot?._id }, { skip: !slot?._id });

  // const { data: { results: dataBigWins = [], count: countBigwins = 0 } = {} } =
  //   useBigwinsByIdSlotQuery({ id: slot?._id ?? '' }, { skip: !slot?._id });

  const navItems: INavItem[] = [
    {
      icon: <Icon.Search width="16" height="16" />,
      text: 'Check RTP',
      anchor: `#${Anchor.slot.checkRTP}`,
    },

    {
      icon: <Icon.Dollar width={16} height={16} />,
      text: 'For Money',
      anchor: `#${Anchor.slot.forMoney}`,
    },
  ];

  return (
    <div className="wrapper">
      <CustomMetadata metadata={allMetadata.slot(slot)} />
      <Layout hasFooter isSearchInputMobileVisible>
        <main className={styles.main}>
          <div className={styles.container_s}>
            <div className={styles.breadcrumbs}>
              <Breadcrumbs
                enableAbsoluteOnMobile={false}
                items={[
                  ...slotPageBreadCrumbs,
                  {
                    id: 2,
                    path: Routes.slotPage(getItemIdentifier(slot)),
                    title: slot?.name ?? '',
                  },
                ]}
              />
            </div>
            <Slot data={slot} />
            <Description isSlot data={slot} />

            <div className={styles.navigation}>
              <NavigationBar
                items={navItems}
                navItemClassName={styles.navItem}
                arrow
                variantBg="notransparent"
                variantPadding="medium"
              />
            </div>

            <PlayBlock slot={slot} />

            <CheckRtpBlock
              id={Anchor.slot.checkRTP}
              title={slot?.name}
              provider={slotProvider}
            />

            <VideoSlider videoLinks={slot.bigwinsLinks} />

            <div id={Anchor.slot.reviews} className="anchor" />
            <CardsMedium
              container="mini"
              name={`${slot?.name} for real money`}
              data={forRealMoneyCasinos}
              url={Routes.slotForRealMoneyPage(getItemIdentifier(slot))}
            />

            <Reviews
              isSlot
              slot={slot}
              isSeeMoreVisible
              count={countReviews}
              userReviews={reviews}
              name={`${slot?.name} player reviews and rank`}
            />
            <FAQComponent
              customFaq={slot.faq}
              titleClassName={styles.faq_title}
            />
            {/* <CardsBig
              container="mini"
              name={`${slot?.name} big wins`}
              data={dataBigWins.slice(0, 2)}
              count={countBigwins.toString()}
              url={Routes.slotBigWinsPage(getItemIdentifier(slot))}
            /> */}
          </div>
        </main>
      </Layout>
    </div>
  );
};
